var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保单信息")))])]), _c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      },
      rules: _vm.dataRule
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保单归属")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.policInfo.customerName,
      callback: function ($$v) {
        _vm.$set(_vm.policInfo, "customerName", $$v);
      },
      expression: "policInfo.customerName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保单来源")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.policInfo.applicationName,
      callback: function ($$v) {
        _vm.$set(_vm.policInfo, "applicationName", $$v);
      },
      expression: "policInfo.applicationName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品名称")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.policInfo.insuranceName,
      callback: function ($$v) {
        _vm.$set(_vm.policInfo, "insuranceName", $$v);
      },
      expression: "policInfo.insuranceName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保单号"),
      prop: "policyNo"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("保单号")
    },
    model: {
      value: _vm.form.policyNo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "policyNo", $$v);
      },
      expression: "form.policyNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保险方案"),
      prop: "planId"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.policInfo.planName,
      callback: function ($$v) {
        _vm.$set(_vm.policInfo, "planName", $$v);
      },
      expression: "policInfo.planName"
    }
  }), _vm.planList.length != 0 ? _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        _vm.palnShow = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("方案说明")))]) : _vm._e()], 1)])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("承保单位")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.policInfo.unitName,
      callback: function ($$v) {
        _vm.$set(_vm.policInfo, "unitName", $$v);
      },
      expression: "policInfo.unitName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("机构全称")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.policInfo.agencyName,
      callback: function ($$v) {
        _vm.$set(_vm.policInfo, "agencyName", $$v);
      },
      expression: "policInfo.agencyName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品代码")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.policInfo.insuranceCode,
      callback: function ($$v) {
        _vm.$set(_vm.policInfo, "insuranceCode", $$v);
      },
      expression: "policInfo.insuranceCode"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("中介机构")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.policInfo.intermediaryName,
      callback: function ($$v) {
        _vm.$set(_vm.policInfo, "intermediaryName", $$v);
      },
      expression: "policInfo.intermediaryName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("等待期")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.policInfo.waitTime || 0,
      disabled: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品大类")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.policInfo.insuranceSorName,
      callback: function ($$v) {
        _vm.$set(_vm.policInfo, "insuranceSorName", $$v);
      },
      expression: "policInfo.insuranceSorName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保费")
    }
  }, [!_vm.isAreaPrice ? _c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      disabled: "",
      readOnly: true
    },
    model: {
      value: _vm.form.premiumPrice,
      callback: function ($$v) {
        _vm.$set(_vm.form, "premiumPrice", $$v);
      },
      expression: "form.premiumPrice"
    }
  }) : _c("a-input-group", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      compact: ""
    }
  }, [_c("a-cascader", {
    attrs: {
      disabled: "",
      options: _vm.rearOptions,
      placeholder: _vm.$t("请选择")
    },
    model: {
      value: _vm.codeValue,
      callback: function ($$v) {
        _vm.codeValue = $$v;
      },
      expression: "codeValue"
    }
  }), _c("a-input", {
    staticStyle: {
      width: "120px"
    },
    attrs: {
      disabled: "",
      readOnly: true
    },
    model: {
      value: _vm.form.premiumPrice,
      callback: function ($$v) {
        _vm.$set(_vm.form, "premiumPrice", $$v);
      },
      expression: "form.premiumPrice"
    }
  })], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("生效日期"),
      prop: "startAt"
    }
  }, [_c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      "show-time": "",
      allowClear: "",
      format: _vm.getFormatDate() + " HH:mm:ss" + _vm.dateChronaxie(),
      placeholder: _vm.$t("请输入") + _vm.$t("生效日期")
    },
    on: {
      change: _vm.timeChange
    },
    model: {
      value: _vm.form.startAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "startAt", $$v);
      },
      expression: "form.startAt"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("终止日期"),
      prop: "endAt"
    }
  }, [_c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      "show-time": "",
      allowClear: "",
      disabled: "",
      format: _vm.getFormatDate() + " HH:mm:ss" + _vm.dateChronaxie(),
      placeholder: _vm.$t("请输入") + _vm.$t("终止日期")
    },
    model: {
      value: _vm.form.endAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "endAt", $$v);
      },
      expression: "form.endAt"
    }
  })], 1)], 1), _vm.showRate ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "rate"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t("费率类型")) + "  "), _c("a-tooltip", {
    attrs: {
      overlayClassName: "rate-tooltip"
    }
  }, [_c("template", {
    slot: "title"
  }, [_c("p", [_vm._v(" " + _vm._s(_vm.$t("费率类型：目前只有走“雇主责任险”的险种需要配置")) + " ")]), _c("div", {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t("短期费率与日费率计算区别：")))]), _c("div", {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("选择“短期费率”公式计算为后每人全年保费/365*加/退保天数")) + " ")]), _c("div", {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("选择“日费率”公式计算为：每人全年保费/366*加/退保天数")) + " ")])]), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 2)], 1), _c("a-radio-group", {
    model: {
      value: _vm.form.rate,
      callback: function ($$v) {
        _vm.$set(_vm.form, "rate", $$v);
      },
      expression: "form.rate"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "shortTerm"
    }
  }, [_vm._v(_vm._s(_vm.$t("短期费率")))]), _c("a-radio", {
    attrs: {
      value: "day"
    }
  }, [_vm._v(_vm._s(_vm.$t("日费率")))])], 1)], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("电子保单"),
      prop: "policyUrl"
    }
  }, [_c("a-upload", {
    staticClass: "upload-list-inline",
    attrs: {
      action: _vm.action,
      multiple: true,
      "file-list": _vm.fileList,
      accept: "image/*,.pdf",
      "list-type": "picture-card",
      data: {
        module: "policy"
      },
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      change: _vm.handleChange,
      preview: _vm.handlePreview
    }
  }, [_c("div", [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  }), _c("div", {
    staticClass: "ant-upload-text"
  }, [_vm._v(" " + _vm._s(_vm.$t("上传")) + " ")])], 1)])], 1)], 1)], 1)], 1), _vm.hasAttachInfo ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("附加险信息")))])]) : _vm._e(), _vm.hasAttachInfo ? _c("div", [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("关联附加险"),
      labelCol: {
        span: 2
      },
      "wrapper-col": {
        span: 9
      }
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择"),
      allowClear: false,
      mode: "multiple"
    },
    model: {
      value: _vm.attachValue,
      callback: function ($$v) {
        _vm.attachValue = $$v;
      },
      expression: "attachValue"
    }
  }, _vm._l(_vm.attachOptions, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        disabled: item.disabled,
        value: item.attachId
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1), _c("a-table", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.attachValue && _vm.attachValue.length,
      expression: "attachValue && attachValue.length"
    }],
    staticStyle: {
      width: "80%",
      "margin-left": "8.33%"
    },
    attrs: {
      columns: _vm.columns,
      dataSource: _vm.tableData,
      pagination: false,
      rowKey: "attachId",
      bordered: ""
    },
    scopedSlots: _vm._u([{
      key: "price",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text || text === 0 ? text : "-") + " ")];
      }
    }, {
      key: "amount",
      fn: function (text, record) {
        return [!record.attachPlan || record.attachPlan && record.attachPlan.length <= 1 ? _c("span", [_vm._v(_vm._s(text))]) : _c("a-select", {
          staticStyle: {
            width: "100%"
          },
          attrs: {
            placeholder: _vm.$t("请选择"),
            allowClear: false
          },
          on: {
            select: e => _vm.amountSelect(e, record)
          },
          model: {
            value: record.attachPlanId,
            callback: function ($$v) {
              _vm.$set(record, "attachPlanId", $$v);
            },
            expression: "record.attachPlanId"
          }
        }, _vm._l(record.attachPlan, function (item, index) {
          return _c("a-select-option", {
            key: index,
            attrs: {
              value: item.id
            }
          }, [_vm._v(_vm._s(item.amount))]);
        }), 1)];
      }
    }], null, false, 1217380784)
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("a-form-model-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.tableData.length,
      expression: "tableData.length"
    }],
    attrs: {
      label: _vm.$t("保单类型"),
      labelCol: {
        span: 2
      },
      required: "",
      "wrapper-col": {
        span: 14
      }
    }
  }, [_c("a-radio-group", {
    attrs: {
      defaultValue: 1
    },
    model: {
      value: _vm.form.policyType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "policyType", $$v);
      },
      expression: "form.policyType"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("独立保单")))]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("与主险同一保单")))])], 1)], 1)], 1) : _vm._e(), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("干系人信息")))])]), _vm.isShow ? _c("div", [_c("div", {
    staticClass: "nameBox"
  }, [_vm._v(_vm._s(_vm.$t("投保人信息")))]), _c("div", {
    staticClass: "infoBox"
  }, [_c("a-form-model", {
    ref: "applicantForm",
    attrs: {
      model: _vm.applicantForm,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("投保人类型"),
      required: "",
      prop: "applicantType"
    }
  }, [_c("a-radio-group", {
    on: {
      change: _vm.applicantChange
    },
    model: {
      value: _vm.applicantForm.applicantType,
      callback: function ($$v) {
        _vm.$set(_vm.applicantForm, "applicantType", $$v);
      },
      expression: "applicantForm.applicantType"
    }
  }, _vm._l(_vm.applicantTypeTemOption, function (item) {
    return _c("a-radio", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.value)))]);
  }), 1)], 1)], 1)], 1), _c("a-row", _vm._l(_vm.applicantList, function (item, index) {
    return _c("a-col", {
      key: item.id,
      attrs: {
        span: 12
      }
    }, [_c("a-form-model-item", {
      attrs: {
        label: item.name,
        prop: item.code,
        rules: [{
          required: item.required,
          message: _vm.getErrorMessage(item)
        }, item.display == "text" ? {
          max: 100,
          message: _vm.$t("最多输入100字符")
        } : {}],
        "validate-status": item.checkResult ? "error" : "validating",
        help: item.checkResult ? item.checkResult : ""
      }
    }, [item.display == "text" ? _c("a-input", {
      attrs: {
        placeholder: _vm.$t("请填写") + item.name
      },
      on: {
        change: e => _vm.asyncValue(e, item, "valData")
      },
      model: {
        value: _vm.applicantForm[item.code],
        callback: function ($$v) {
          _vm.$set(_vm.applicantForm, item.code, $$v);
        },
        expression: "applicantForm[item.code]"
      }
    }) : _vm._e(), item.display == "dropDownBox" ? _c("a-select", {
      attrs: {
        placeholder: _vm.$t("请选择") + item.name
      },
      on: {
        change: e => _vm.asyncValue(e, item, "valData", "select")
      },
      model: {
        value: _vm.applicantForm[item.code],
        callback: function ($$v) {
          _vm.$set(_vm.applicantForm, item.code, $$v);
        },
        expression: "applicantForm[item.code]"
      }
    }, _vm._l(item.selectarr, function (item, index) {
      return _c("a-select-option", {
        key: index,
        attrs: {
          value: item.key
        }
      }, [_vm._v(" " + _vm._s(item.value) + " ")]);
    }), 1) : _vm._e(), item.display == "time" ? _c("a-date-picker", {
      staticStyle: {
        width: "100%"
      },
      attrs: {
        allowClear: "",
        format: _vm.getFormatDate(),
        placeholder: _vm.$t("请选择") + item.name
      },
      on: {
        change: e => _vm.asyncValue(e, item, "valData", "select")
      },
      model: {
        value: _vm.applicantForm[item.code],
        callback: function ($$v) {
          _vm.$set(_vm.applicantForm, item.code, $$v);
        },
        expression: "applicantForm[item.code]"
      }
    }) : _vm._e(), item.display == "dropDownBox(region)" ? _c("area-select", {
      attrs: {
        "default-value": item.defaultValue,
        index: index
      },
      on: {
        change: _vm.selectArea
      }
    }) : _vm._e()], 1)], 1);
  }), 1)], 1)], 1), _vm._l(_vm.insuredList, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "nameBox"
    }, [_vm._v(_vm._s(_vm.$t("被保险人信息")) + _vm._s(index == 0 ? "" : index + 1))]), item.length ? _c("a-form-model", {
      ref: "insuredForm",
      refInFor: true,
      attrs: {
        model: _vm.insuredForm,
        "label-col": {
          span: 4
        },
        "wrapper-col": {
          span: 18
        }
      }
    }, [_c("a-row", {
      staticStyle: {
        display: "flex",
        "flex-wrap": "wrap"
      }
    }, _vm._l(item, function (item2, index2) {
      return _c("a-col", {
        key: item2.id,
        attrs: {
          span: 12
        }
      }, [_c("a-form-model-item", {
        attrs: {
          label: item2.name,
          prop: item2.code + index,
          rules: [{
            required: item2.required,
            message: _vm.getErrorMessage(item2)
          }, item2.display == "text" ? {
            max: 100,
            message: _vm.$t("最多输入100字符")
          } : {}],
          "validate-status": item2.checkResult ? "error" : "validating",
          help: item2.checkResult ? item2.checkResult : ""
        }
      }, [item2.display == "text" ? _c("a-input", {
        attrs: {
          placeholder: _vm.$t("请选择") + item2.name
        },
        on: {
          change: e => _vm.asyncValue(e, item2, "valData")
        },
        model: {
          value: _vm.insuredForm[item2.code + index],
          callback: function ($$v) {
            _vm.$set(_vm.insuredForm, item2.code + index, $$v);
          },
          expression: "insuredForm[item2.code + index]"
        }
      }) : _vm._e(), item2.display == "dropDownBox" ? _c("a-select", {
        attrs: {
          placeholder: _vm.$t("请选择") + item2.name
        },
        on: {
          change: e => _vm.asyncValue(e, item2, "valData", "select")
        },
        model: {
          value: _vm.insuredForm[item2.code + index],
          callback: function ($$v) {
            _vm.$set(_vm.insuredForm, item2.code + index, $$v);
          },
          expression: "insuredForm[item2.code + index]"
        }
      }, _vm._l(item2.selectarr, function (item3, index3) {
        return _c("a-select-option", {
          key: index3,
          attrs: {
            value: item3.key
          }
        }, [_vm._v(" " + _vm._s(item3.value) + " ")]);
      }), 1) : _vm._e(), item2.display == "time" ? _c("a-date-picker", {
        staticStyle: {
          width: "100%"
        },
        attrs: {
          allowClear: "",
          format: _vm.getFormatDate(),
          placeholder: _vm.$t("请选择") + item2.name
        },
        on: {
          change: e => _vm.asyncValue(e, item2, "valData", "select")
        },
        model: {
          value: _vm.insuredForm[item2.code + index],
          callback: function ($$v) {
            _vm.$set(_vm.insuredForm, item2.code + index, $$v);
          },
          expression: "insuredForm[item2.code + index]"
        }
      }) : _vm._e(), item2.display == "dropDownBox(region)" ? _c("area-select", {
        attrs: {
          "default-value": item2.defaultValue,
          index: index,
          index2: index2
        },
        on: {
          change: _vm.selectArea
        }
      }) : _vm._e()], 1)], 1);
    }), 1)], 1) : _vm._e()], 1);
  }), _c("a-form-model", {
    attrs: {
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-col", {
    staticClass: "btnBox",
    attrs: {
      span: 24
    }
  }, [_c("a-button", {
    attrs: {
      type: "add",
      loading: _vm.loading
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))])], 1)], 1)], 2) : _vm._e(), _c("a-modal", {
    attrs: {
      visible: _vm.previewVisible,
      footer: null,
      width: 800
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  }, [_c("img", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      alt: "example",
      src: _vm.previewImage
    }
  })]), _c("paln-model", {
    attrs: {
      dialogVisible: _vm.palnShow,
      list: _vm.planList
    },
    on: {
      cancel: function ($event) {
        _vm.palnShow = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };